"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GroupVisibility = void 0;
var GroupVisibility;
exports.GroupVisibility = GroupVisibility;

(function (GroupVisibility) {
  GroupVisibility["Public"] = "public";
  GroupVisibility["Private"] = "private";
  GroupVisibility["Hidden"] = "hidden";
})(GroupVisibility || (exports.GroupVisibility = GroupVisibility = {}));